module.exports = __webpack_public_path__ + "static/media/StudentResultData.c03fa091.xlsx";